export default __webpack_public_path__ + "static/media/a.532ab58b.jpg";